<script>

import FormErrors from '@/util/form-errors'
import errorsMixin from '@/mixins/errors.mixin'
import DrivingSchoolValidator from "../core/models/drivingSchoolValidator"
import {DrivingSchoolService as Svc} from "../core/driving-school.service"

export default {
  name: 'drivingSchoolAdd',
  mixins: [errorsMixin],
  props: {
  },
  
  render() {
    return this.$scopedSlots.default({
      showing: this.showing,
      toggle: this.toggle,
      formErrors: this.formErrors,
      checkValidatorBeforeSend: this.checkValidatorBeforeSend,
      updateShowing: this.updateShowing,
      formData: this.formData,
      updateFormData: this.updateFormData
    })
  },

  data:() => ({
    showing: false,
    processing: false,
    formErrors: new FormErrors(),
    formData: {
      name: '',
      number: null,
      slug: ''
    }
  }),

  methods: {
    toggle() {
      this.showing = !this.showing
    },

    updateShowing(val) {
      this.showing = val
    },

    updateFormData({field, val}) {
      this.formData[field] = val
    },

    checkValidatorBeforeSend(data) {
      if(!new DrivingSchoolValidator(data, this.formErrors).validate()) {
        this.$notify({text:'Invalid fields', type: 'error'})
        return
      }
      this.send(data)
    },

    async send(data) {
      try {
        this.processing = true
        let res = await new Svc().post(data)
        this.$emit('create', res)
        this.$notify({text: 'Driving school created', type: 'success'})
        this.toggle()
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.processing = false
      }
    },

    reset() {
      this.formData = {
        name: '',
        number: null,
        slug: ''
      }
    }
  },

  watch: {
    showing(isShowing) {
      if(isShowing) {
        this.reset()
      }
    }
  }
}
</script>